const types = {};

types.SET_GLOBAL_RESPONSE_STATUS = 'SET_GLOBAL_RESPONSE_STATUS';

export default types;



// WEBPACK FOOTER //
// ./src/screens/Status/store/types.js